import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import {ThumbUpAlt} from '@material-ui/icons';
import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

interface IPropsDialog {
  open: boolean;
  min: number;
  max: number;
  onClose: () => void;
}

const InvalidVotingDialog: React.FC<IPropsDialog> = ({
  open,
  min,
  max,
  onClose,
}) => {
  const {t} = useTranslation();
  const getMessage = () => {
    let message;

    const optionMax =
      max <= 1
        ? `${max} ${t('votacao-invalida.opcao')}`
        : `${max} ${t('votacao-invalida.opcoes')}`;

    if (min <= 1 && max <= 1) {
      message = (
        <Trans
          i18nKey="votacao-invalida.escolha-uma-opcao"
          shouldUnescape={true}
          components={{strong: <strong />}}
          values={{characters: escape('<, >, &')}}
        />
      );
    } else if (!min && max > 0) {
      message = (
        <>
          {t('votacao-invalida.escolher-no-max')} <strong>{optionMax}</strong>,
        </>
      );
    } else if (min === max && min !== 1) {
      message = (
        <>
          {t('votacao-invalida.voce-precisa-escolher')}{' '}
          <strong>{optionMax}</strong>,
        </>
      );
    } else {
      message = (
        <Trans
          i18nKey="votacao-invalida.escolher-entre-minimo-e-maximo"
          shouldUnescape={true}
          components={{strong: <strong />}}
          values={{
            characters: escape('<, >, &'),
            minimo: min,
            maximo: optionMax,
          }}
        />
      );
    }

    return message;
  };

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={onClose}
      className="confirm-voting-dialog"
    >
      <DialogTitle>{t('votacao-invalida.quantidade-invalida')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {getMessage()} {t('votacao-invalida.para-confirmar-voto')}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          className={`button-default btn-green ddd full-width`}
          type="button"
          color="primary"
          variant="contained"
          onClick={onClose}
          startIcon={<ThumbUpAlt />}
        >
          {t('votacao-invalida.entendi')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidVotingDialog;



// WEBPACK FOOTER //
// ./src/features/election/components/InvalidVotingDialog.tsx